import styled from 'styled-components';
import StickyHeader from 'components/StickyHeader';

export const Container = styled.div`
  margin-bottom: 5rem;
`;

export const Header = styled(StickyHeader)``;
